import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('whatsapp');

export class Templates extends Api {
  constructor(http, config = {}) {
    super(http, url, 'templates', config);
  }
}